import { render, staticRenderFns } from "./main-about.vue?vue&type=template&id=70fae78f&scoped=true"
import script from "./main-about.vue?vue&type=script&lang=js"
export * from "./main-about.vue?vue&type=script&lang=js"
import style0 from "./main-about.vue?vue&type=style&index=0&id=70fae78f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fae78f",
  null
  
)

export default component.exports